import ConvertRecordingLogic from "../../components/RecordingFeatures/ConvertRecording";

const ConvertRecordingPage = () => {

    return (
        <div className="vr-edit-page">
            <ConvertRecordingLogic />
        </div>
    );
};

export default ConvertRecordingPage;
